module.exports = __webpack_public_path__ + "img/icon_check_light.d14c7306.svg";